import React, { useState, useEffect } from "react";
import { useHistory} from "react-router-dom";
import { onError } from "../libs/errorLib";

import { API } from "aws-amplify";
import "./Sites.css";
//import LoaderButton2 from "../components/LoaderButton2";
//import LoaderButton3 from "../components/LoaderButton3";

import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import { BsArrowRepeat } from "react-icons/bs";


import Table from "react-bootstrap/Table";

import { makeStyles, withStyles, styled } from '@material-ui/core/styles';


import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import Button from '@material-ui/core/Button';
//import Button from "../components/LoaderButtonX";
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';

import ButtonBase from '@material-ui/core/ButtonBase';


import Fab from '@material-ui/core/Fab';


import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

//import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
//import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
//import Brightness3Icon from '@material-ui/icons/Brightness3';
//import InvertColorsIcon from '@material-ui/icons/InvertColors';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

//import PictureAsPdfRoundedIcon from '@material-ui/icons/PictureAsPdfRounded';

import iTopOvernightOff from'../images/preview/Pay Per Night - Grey.svg';
import iTopBaysOff from'../images/preview/Parking - Grey.svg';
import iTopFacilitiesOff from'../images/preview/Facilities Only - Grey.svg';

import iTopOvernight from'../images/preview/Pay Per Night - Blue.svg';
import iTopBays from'../images/preview/Parking - Blue.svg';
import iTopFacilities from'../images/preview/Facilities Only - Blue.svg';


import iRecyclingOff from'../images/facilities/Recycling - Grey.svg';
import iBlackWaterOff from'../images/facilities/Black Water Disposal - Grey.svg';
import iElectricOff from'../images/facilities/Electric Hook Up - Grey.svg';
import iGreyWaterOff from'../images/facilities/Grey Water Disposal - Grey.svg';
import iLaundryOff from'../images/facilities/Laundry - Grey.svg';
import iOvernightOff from'../images/facilities/Overnight Parking - Grey.svg';
import iRubbishOff from'../images/facilities/Rubbish - Grey.svg';
import iShowerOff from'../images/facilities/Shower - Grey.svg';
import iToiletOff from'../images/facilities/Toilet - Grey.svg';
import iWaterOff from'../images/facilities/Water - Grey.svg';
import iWifiOff from'../images/facilities/Wifi - Grey.svg';

import iRecycling from'../images/facilities/Recycling - Coral.svg';
import iBlackWater from'../images/facilities/Black Water Disposal - Coral.svg';
import iElectric from'../images/facilities/Electric Hook Up - Coral.svg';
import iGreyWater from'../images/facilities/Grey Water Disposal - Coral.svg';
import iLaundry from'../images/facilities/Laundry - Coral.svg';
import iOvernight from'../images/facilities/Overnight Parking - Coral.svg';
import iRubbish from'../images/facilities/Rubbish - Coral.svg';
import iShower from'../images/facilities/Shower - Coral.svg';
import iToilet from'../images/facilities/Toilet - Coral.svg';
import iWater from'../images/facilities/Water - Coral.svg';
import iWifi from'../images/facilities/Wifi - Coral.svg';



import iCampra from'../images/campra/Campra Accredited - Green.svg';

import defaultSiteImage from'../images/Default-Image-Road.jpg';
import spinner from'../images/Driving-SVG.gif';


import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';


import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import Container from '@material-ui/core/Container';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';


import Form from "react-bootstrap/Form";

import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline';

import parse from 'html-react-parser';


import jsPDF from 'jspdf';

import iLogo from "../images/logo.jpg";
import iQRLogo from "../images/qrcode_logo.svg";

import iCampraA from'../images/campra/Campra Accredited - Green.svg';
import iCampraX from'../images/campra/Campra Accredited - Grey.svg';


import QRCode from 'qrcode';
import { createCanvas, loadImage } from "node-canvas";

import '../fonts/Montserrat-Regular-normal.js';


//import CheckboxLabels from "../components/CheckboxLabels";
const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'white',
    },

  },
})(TextField);

const BlueTooltip = withStyles((theme) => ({
  arrow: {
    "&:before": {
      border: "1px solid #10385A"
    },
    color: '#10385Acc'
  },
  tooltip: {
    backgroundColor: '#10385Add',
    color: '#ffffff',
    border: "1px solid #10385A",
    fontSize: 12,
    fontFamily: "Montserrat",
    fontWeight: 400,

  },
}))(Tooltip);


const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      background: "#000",
    },
  },
  imageList: {
    width: 500,
    height: 48,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  card: {
    margin: theme.spacing(2),
  },
  h4: {
    fontFamily: 'Comfortaa',
    color: '#10385A4'
  },

  dialogContent: {
    width: '100%',
    backgroundColor: '#10385A',
    paddingTop: '80px',
    height:"100vh",
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
    color: 'white'
  },
  pdf: {cursor:'pointer', marginTop: '-0px', marginRight: '-8px', color:'#10385A4'},

  link: {
      color: "#F18C7E",
      "&:hover": {
          color: "#F18C7E",
          textDecoration: "underline #F18C7E"
      }
  },
  spreadBox: {
    justifyContent: "space-between"
  },

  textField: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "red"
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "red"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "red"
    },
    "& .MuiOutlinedInput-input": {
      color: "red"
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "red"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "red"
    },
    "& .MuiInputLabel-outlined": {
      color: "red"
    },
    "&:hover .MuiInputLabel-outlined": {
      color: "red"
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "red"
    },


  }



}







));


const useViewport = () => {
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return the width so we can use it in our components
  return { width };
}




export default function Sites() {
  let classes = useStyles();

  const history = useHistory();
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    reg: "",
  });
  const [tncs, setTncs] = useState(false);

  const { isCampra } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);
  const [switchingId, setSwitchingId] = useState(null);

  const [open, setOpen] = React.useState(false);
  const [paymentResult, setPaymentResult] = React.useState(false);
  const [sessionValues, setSessionValues] = React.useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const [alertVals, handleAlertChange] = useFormFields({
    title: "",
    message: "",
  });



  const [currentSite, setCurrentSite] = useState(null);
  const [content, setContent] = useState("");
  const [siteOpen, setSiteOpen] = useState(false);
  //const [base64Image, setBase64Image] = useState("");
  //const [siteCode, setSiteCode] = useState("");
  //const [desc, setDesc] = useState("");
  //const [rules, setRules] = useState("");
  const [address, setAddress] = useState("");
  //const [accreditations, setAccreditations] = useState([]);


  const [sites, setSites] = useState([]);










  const { width } = useViewport();
  const breakpoint = 600;

  useEffect(() => {

    onLoad();
  }, []);



function getDayRange() {
  var d = new Date();
  d.setHours(0,0,0,0);
  var t1 = d.getTime();
  return {start: t1, end: t1 + 86400000};
}


  function getTransactions() {
    return API.post("aires", `/tran`, {
      body: getDayRange()
    });
  }




  function getSites() {
    return API.get("aires", `/sites`);
  }

  async function onLoad() {
    if (isCampra) {history.push("/")}
    setIsLoading(true);
    try {
      const result = await getSites();
      if (result.status && result.data) {
        result.data.forEach(site => {
          site["trans"] = {"overnight": []};
          site.trans["facilities"] = [];
        });
        result.data.push({add: true});
        setSites(result.data);
        if (result.data.length>1) {
          const trans = await getTransactions();
          if (trans.status && trans.data && trans.data.length>0)  {
            trans.data.forEach(tran => {
              const code = tran.sk.split("|")[2];
              var site = result.data.find(obj => {
                return obj.itemCode === code;
              })
              if (tran.content.metadata.payType==="overnight") {
                site.trans.overnight.push(tran.vreg);
              } if (tran.content.metadata.payType==="facilities") {
                site.trans.facilities.push(tran.vreg);
              }
            });
          }
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
        alertVals.title="AireStop - Oops!";
        alertVals.message="Unable to retrieve sites, please check your internet connection and try later.";
        setAlertOpen(true);
      }
    } catch (e) {
      onError(e);
      history.push("/");
    }
  }


  const OpenClosedSwitch = withStyles({
    switchBase: {
      color: red[700],
      '&$checked': {
        color: green[500],
      },
      '&$checked + $track': {
        backgroundColor: green[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);


  function handleAlertClose() {
    setAlertOpen(false);
    setDeleteAlertOpen(false);
  };


function handleNewSiteClick() {
  history.push("/sites/create/new");
}

function handleEditSiteClick(site) {
  history.push("/sites/" + site.itemCode + "/edit");
}



/*

{site.trans?
<Box pb={1}>
<Link component="button" disabled={site.trans.overnight.length==0} onClick={() => { handleOvernightTransClick(site) }}>Overnight: {site.trans.overnight.length}</Link> &nbsp;&nbsp;&nbsp;&nbsp;
<Link component="button" disabled={site.trans.facilities.length==0} onClick={() => { handleFacilitiesTransClick(site) }}>Facilities: {site.trans.facilities.length}</Link>

  <Divider width="100%"/>
</Box>
:<></>}


*/



function handleTransactionsClick(site) {
  alertVals.title=<>Todays Bookings<br/><span style={{fontSize:"14px"}}>{site.content.siteName}</span></>;
  alertVals.message=<><b>Overnight Stays</b> ({site.trans.overnight.length})<br/>
  {site.trans.overnight.length>0?

  <>Vehicle registration{site.trans.overnight.length>1?"s":""}:<br/>{
     site.trans.overnight.map((reg, index) => {
      return (
        <><i>{reg.toUpperCase()}</i><br/></>
      )
    })

  }
  </>
  :
  <></>

  }
  <br/>
  <b>Facilities Use</b> ({site.trans.facilities.length})<br/>

  {site.trans.facilities.length>0?

  <>Vehicle registration{site.trans.facilities.length>1?"s":""}:<br/>{
     site.trans.facilities.map((reg, index) => {
      return (
        <><i>{reg.toUpperCase()}</i><br/></>
      )
    })
  }
  </>
  :
  <></>


  }
  </>;
  setAlertOpen(true);
}



function handlePrintSiteClick(site) {
  handlePrintPDF(site);
}
function handleOrderSiteClick(site) {
  history.push("/shop");
}
function handleDeleteSiteClick(site) {
  alertVals.title="AireStop - Confirm Delete";
  alertVals.message="Are you sure you wish to delete this AireStop. This cannot be undone and your customers will lose access to this site.";
  setCurrentSite(site);
  setDeleteAlertOpen(true);
}

async function handleSiteDelete(e) {
  e.preventDefault();
  setIsLoading(true);
  setDeleteAlertOpen(false);
  const newStatus = 9; //DELETED
  const result = await updateSiteStatus(currentSite.itemCode, newStatus);
  if (result.status) {
    setCurrentSite(null);
  }
  onLoad(); //refresh sites list
}


const handleSiteOpenChange = async (event) => {
  event.preventDefault();
  setSwitchingId(event.target.id);
  setIsSwitching(true);
  const newStatus = event.target.checked?1:0;
  const result = await updateSiteStatus(sites[event.target.id].itemCode, newStatus);
  if (result.status) {
    sites[event.target.id].itemStatus=result.result.Attributes.itemStatus;
    setSiteOpen(!siteOpen);
  }
  setIsSwitching(false);
  setSwitchingId(null);
}

function updateSiteStatus(id, status) {
  return API.put("aires", `/sites/${id}`, {body: {
    type: 'STATUS',
    status: status
  }});
}

async function handlePrintPDF(site) {
  const datestr = (new Date(Date.now())).toLocaleString();
  const fileName = "AireStop_" + site.itemCode + "_" + site.content.siteName.replace(/\s/g, '_') + "_" + datestr + ".pdf";
  var doc = new jsPDF('l', 'px', 'a4');


  //doc.setFont('AvenirNextLTPro-Regular'); // set custom font
  doc.setFont('Montserrat-Regular'); // set custom font
  doc.setTextColor(16, 56, 90);
  doc.setCharSpace(6);

  const canvas = createCanvas(300, 300);
  const data = 'https://airestop.co.uk/sites/' + site.itemCode;
  const img = await loadImage(iQRLogo);

  var iii = new Image();
  iii.onload = function(){
      let zzz = doc.getImageProperties(iii);
  };

  QRCode.toCanvas(canvas, data,  {
      errorCorrectionLevel: "H",
      margin: 0,
      color: {
        dark: "#10385A",
        light: "#ffffff",
      },
      width: 300
    }
, function (error) {
      if (error) {
        console.error(error)
      } else {
      const ctx = canvas.getContext("2d");
      const w = 50*2;
      const h = 42.801556*2;
      const ctrex = (300-w) / 2;
      const ctrey = (300-h) / 2;
      ctx.drawImage(img, ctrex, ctrey, w, h);
      const b64qrcode = canvas.toDataURL("image/png");


      iii.src = b64qrcode;


      doc.setProperties({
      	title: 'AireStop Notice',
      	subject: site.content.siteName + " (" + site.itemCode + ")",
      	author: 'AireStop Limited',
      	keywords: '',
      	creator: 'AireStop Limited'
      });

      let pr = doc.getImageProperties(iLogo);
      const rat = pr.height/pr.width;
      doc.setFontSize(70);
      let tr = doc.getTextWidth(site.content.siteName);
      let docw = doc.internal.pageSize.width;
      let doch = doc.internal.pageSize.height;
      let margin = 60;
      let ypos = 30;
      let boxY = 0;
      doc.setFillColor(255,255,255);
      doc.rect(0, 0, docw, doch, 'F');

      doc.addImage(iLogo, "JPG", margin, ypos+10, docw-(margin*2),((docw-(ypos*2))*rat)-15);
      ypos = ypos + (docw-(ypos*2))*rat + 15;
      doc.setDrawColor(16, 56, 90);
      doc.setLineWidth(2);
      doc.setFillColor(0);
      doc.rect((margin/2), ypos, docw-(margin), 200, 'D');
      boxY = ypos;
      doc.addImage(b64qrcode, "PNG", docw-(margin/2)-185, ypos+16);
      doc.setFontSize(70);
      ypos += (16 + 40);
      doc.text("PAY HERE", (margin/2) + 12, ypos);
      doc.setFontSize(22);
      ypos += (10 + 16);
      doc.text("WWW.AIRESTOP.CO.UK", (margin/2) + 16, ypos);
      doc.setFontSize(30);
      doc.text("SITE CODE", (margin/2) + 16, boxY+200-16-50);
      doc.setFontSize(70);
      doc.text(site.itemCode, (margin/2) + 16, boxY+200-16);

      doc.setFontSize(30);


      tr = doc.getTextWidth(site.content.siteName.toUpperCase());
      doc.text(site.content.siteName.toUpperCase(), ((docw-tr)/2)-6, doch-75);
      doc.setLineWidth(1);
      doc.setFontSize(22);
      tr = doc.getTextWidth("ENJOY YOUR VISIT - LEAVE NO TRACE");
      doc.text("ENJOY YOUR VISIT - LEAVE NO TRACE", ((docw-tr)/2)-22, doch-40);
      doc.line(((docw-tr)/2)-22, doch-63, ((docw-tr)/2) + tr + 22, doch-63);
      doc.save(fileName);
}


   })


}




function renderAdd() {
  return (<>  <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"

    >

        <Button variant="contained" color="secondary"  onClick={() => { handleNewSiteClick() }}>
          Add new AireStop
        </Button>

        </Box>
</>);
}

function renderSite(site, index) {
  return (<><div>




  <Box display="flex" flexWrap="wrap"  alignItems='top' className={classes.spreadBox}>

  <Box display="flex" width="100%" flexWrap="wrap" justifyContent="top" alignItems='center' className={classes.spreadBox} >
  <Box display="flex" flexWrap="wrap" mb={1} className={classes.spreadBox} flexDirection="column" justifyContent="center" alignItems='center' mx={0} alignItems='top'>
  <span className="text-muted">{site.itemCode}</span>
  <h4 className={classes.h4}><span>{site.content.siteName}</span></h4>


  </Box>


  <FormControlLabel
  style={{marginRight:"4px"}}
  control={
    <>
    {isSwitching && switchingId && switchingId==index?
    <BsArrowRepeat className="spinning" />
    :<></>}
    <OpenClosedSwitch id={index}
    checked={site.itemStatus==1}
    onChange={handleSiteOpenChange}

    name="siteOpen"
    color="secondary"
    />
    </>
  }
  label={ site.itemStatus==1?"Open":"Closed"}
  />



  </Box>
  </Box>







  <Paper variant="outlined">
  <Grid container justifyContent="center" alignItems='center' spacing={0}>
  <Grid key={1} item>
    <BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"AireStop is "+(site.itemStatus==1?"Open":"Closed")}><Box className="noselect" display="flex" flexWrap="wrap" my={0.3} mr={1} alignItems='center'><FiberManualRecordIcon style={site.itemStatus==1?{ color: green[700] }:{ color: red[700] }} />{site.itemStatus==1?'Open':'Closed'}</Box></BlueTooltip>
  </Grid>
  <Grid key={2} item>
    <BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Overnight Parking (including facilities use)"}><Box className="noselect" display="flex" flexWrap="wrap" my={0.3}  mx={1} alignItems='center'><img src={site.content.priceStay==null || site.content.priceStay==""?iTopOvernightOff:iTopOvernight} width='auto' height='28'/>&nbsp;{(site.content.priceStay==null || site.content.priceStay=="")?"":(site.content.priceStay>0?"£"+site.content.priceStay:"free")}</Box></BlueTooltip>
  </Grid>
  <Grid key={3} item>
    <BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Facilities use only"}><Box className="noselect" display="flex" flexWrap="wrap" my={0.3}  mx={1} alignItems='center'><img src={site.content.priceFacilities==null || site.content.priceFacilities==''?iTopFacilitiesOff:iTopFacilities} width='auto' height='28'/>&nbsp;{site.content.priceFacilities==null || site.content.priceFacilities==''?"":(site.content.priceFacilities>0?"£"+site.content.priceFacilities:"free")}</Box></BlueTooltip>
  </Grid>
  <Grid key={4} item>
    <BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"No. Of Parking Bays"}><Box className="noselect" display="flex" flexWrap="wrap" my={0.3}  mx={1} alignItems='center'><img src={site.content.bays>0?iTopBays:iTopBaysOff} width='auto' height='24'/>&nbsp;{site.content.bays>0?site.content.bays:""}</Box></BlueTooltip>
  </Grid>
  <Grid key={5} item>
    <BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"CAMpRA have"+(site.accreditations?" ":" not ")+"accredited this Aire"}><Box className="noselect" display="flex" flexWrap="wrap" my={0.3}  ml={1} alignItems='center'><img src={site.accreditations?iCampraA:iCampraX} width='auto' height='18'/></Box></BlueTooltip>
  </Grid>
   </Grid>
</Paper>
<br/>


</div>
<div>


<Grid container spacing={1}  wrap='nowrap'>
  <Grid item >
  <Img alt="sitepic" src={site.image?site.image:defaultSiteImage} style={{borderRadius: '4px'}}/>

  </Grid>

  </Grid>





<div>
<Box display="flex" width="100%" flexDirection="column" justifyContent="center" alignItems='center' >
<Box display="inline-block" my={1} justifyContent="center" alignItems='center' flexDirection="column">
<Box display="flex" flexWrap="wrap" p={-0.3}
  justifyContent="center"
  alignItems="center"
  width="100%"
>


<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Overnight Parking is"+(site.content.facilities.facONS?"":" not")+" available."}><img src={site.content.facilities.facONS?iOvernight:iOvernightOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Black Water Disposal is"+(site.content.facilities.facBWD?"":" not")+" available."}><img src={site.content.facilities.facBWD?iBlackWater:iBlackWaterOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Grey Water Disposal is"+(site.content.facilities.facGWD?"":" not")+" available."}><img src={site.content.facilities.facGWD?iGreyWater:iGreyWaterOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Drinking Water is"+(site.content.facilities.facWTR?"":" not")+" available."}><img src={site.content.facilities.facWTR?iWater:iWaterOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Electric Hookup is"+(site.content.facilities.facEHU?"":" not")+" available."}><img src={site.content.facilities.facEHU?iElectric:iElectricOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Rubbish Bins are"+(site.content.facilities.facRUB?"":" not")+" available."}><img src={site.content.facilities.facRUB?iRubbish:iRubbishOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Recycling Bins are"+(site.content.facilities.facREC?"":" not")+" available."}><img src={site.content.facilities.facREC?iRecycling:iRecyclingOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Toilet is"+(site.content.facilities.facTLT?"":" not")+" available."}><img src={site.content.facilities.facTLT?iToilet:iToiletOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Shower is"+(site.content.facilities.facSWR?"":" not")+" available."}><img src={site.content.facilities.facSWR?iShower:iShowerOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Laundry is"+(site.content.facilities.facLND?"":" not")+" available."}><img src={site.content.facilities.facLND?iLaundry:iLaundryOff} width='40' height='40'/></BlueTooltip></Box>
<Box component="span" p={0.3} ><BlueTooltip arrow placement="top" enterTouchDelay={100} enterDelay={50} title={"Wifi is"+(site.content.facilities.facWFI?"":" not")+" available."}><img src={site.content.facilities.facWFI?iWifi:iWifiOff} width='40' height='40'/></BlueTooltip></Box>


</Box></Box>


</Box>

</div>

</div>


<div>
<Box display="flex" width="100%" flexDirection="column" justifyContent="center" alignItems='center'>

<Box display="inline-block" my={1}>
<Paper elevation={5} >

<Box display="flex" flexWrap="wrap"
  justifyContent="center"
  alignItems="center"
  width="100%"
>



    <Box  whiteSpace="nowrap"  p={1} >

    <Fab size="small" color="primary" aria-label="add" variant="extended" onClick={() => { handleEditSiteClick(site) }}>
    <span class="material-icons-round" style={{ color: "#fff"}}>
      edit
    </span>
    <span style={{ color: "#fff"}}>
    &nbsp;Edit Profile
    </span>
    </Fab>

    </Box>
    <Box  whiteSpace="nowrap"  p={1} >
    <Fab size="small" color="primary" aria-label="add" variant="extended" onClick={() => { handlePrintSiteClick(site) }}>
    <span class="material-icons-round" style={{ color: "#fff"}}>
      picture_as_pdf
    </span>
    <span style={{ color: "#fff"}}>
    &nbsp;Print Sign
    </span>
    </Fab>



    </Box>
    <Box  whiteSpace="nowrap"  p={1} >
    <Fab size="small" color="primary" aria-label="add" variant="extended" onClick={() => { handleOrderSiteClick(site) }}>
    <span class="material-icons-round" style={{ color: "#fff"}}>
      storefront
    </span>
    <span style={{ color: "#fff"}}>
    &nbsp;Order Signs
    </span>
    </Fab>

    </Box>

    <Box  whiteSpace="nowrap"  p={1} >
    <Fab size="small" color="primary" aria-label="add" variant="extended" onClick={() => { handleTransactionsClick(site) }}>
    <span class="material-icons-round" style={{ color: "#fff"}}>
      menu_book
    </span>
    <span style={{ color: "#fff"}}>
    &nbsp;Guest Log
    </span>
    </Fab>

    </Box>

    <Box  whiteSpace="nowrap"  p={1}  >

    <Fab size="small" color="primary" aria-label="add" variant="extended" onClick={() => { handleDeleteSiteClick(site) }}>
    <span class="material-icons-round" style={{ color: "#fff"}}>
      delete_forever
    </span>
    </Fab>
    </Box>


  </Box>
</Paper>

  </Box>  </Box>

  </div>


</>);





}

function renderLoader() {
  return (
    <div id="splash" style={{paddingTop: 100, zIndex:999}}>

      <center id="splash">
        <img src={spinner} height="30px" width="auto"/>
        {/*}<Typography style={{padding: '4px'}} variant="caption">{label}</Typography>*/}
      </center>
    </div>


  );

}


  function renderLander() {
    return (
      <div style={isSwitching?{pointerEvents: "none", opacity: "0.7"}:{}}>
        <Box display="flex" flexDirection="column" flexWrap="nowrap" my={0}  mx={2} alignItems='top'>
        <Box display="flex" flexWrap="wrap" mb={0}  mx={0} alignItems='top'> <h2  className={classes.h2}>My AireStops</h2>  </Box>
        <Box mx={0.5}>
        {sites.length>1?
          <p>This is where you can find, manage and edit your AireStop{sites.length>1?"s":""}</p>
        :
          <p>Create you first AireStop site.</p>
        }
        </Box>
        </Box>
        <Box display="flex" width="100%" flexDirection="column" justifyContent="center" alignItems='center'>
        {renderSites()}
        </Box>
      </div>
    );
  }

  function renderSites() {
    return sites.map((site, index) => {
      return (
        <>

        <Box maxWidth="650px">
        <Card className={classes.card}>
          <CardContent>
            {site.add?renderAdd():renderSite(site, index)}
          </CardContent>
        </Card>
        </Box>
        </>
      );
    })
  }




  return (

    <div className="Sites">
      {isLoading?renderLoader():renderLander()}
      <Dialog
      open={alertOpen || deleteAlertOpen}
      fullWidth={false}
      maxWidth = {'md'}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      >
      <DialogTitle id="alert-dialog-slide-title" style={{color:"#10385A"}} >
      {alertVals.title}
      </DialogTitle>
      <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
      {alertVals.message}
      </DialogContentText>
      </DialogContent>
      <DialogActions>
      {deleteAlertOpen?
        <>
        <Button onClick={handleAlertClose} color="primary">
        Cancel
        </Button>
        <Button onClick={handleSiteDelete} color="secondary">
        Delete
        </Button>
      </>
      :
      <Button onClick={handleAlertClose} color="secondary">
      Ok
      </Button>
    }
      </DialogActions>
      </Dialog>
    </div>
  );
}
